import {fetchUserLastInquiry,postPaymentWallet,postRequestSendBank,} from "@/api/user/home";
import useThousandsSeparator, {toPersianNumber,} from "@/hooks/useThousandsSeparator";
import BoxKit from "@/shared/components/kit/box";
import CustomButton from "@/shared/components/kit/button";
import AlertDialog from "@/shared/components/kit/modal";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import {Divider,List,ListItem,ListItemIcon,ListItemText,} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CardBoxLayout from "@/modules/merchant/layout/cardBoxLayout";

/**
 * ContentValidation
 *
 * کامپوننت مربوط به نمایش مراحل اعتبارسنجی و پرداخت هزینه آن.
 * - نمایش اطلاعات هزینه اعتبارسنجی و موجودی کیف پول.
 * - امکان پرداخت هزینه اعتبارسنجی از طریق کیف پول یا درگاه بانکی.
 * - نمایش راهنمای اعتبارسنجی و مدارک مورد نیاز.
 * - شامل مودال تایید برای پرداخت از کیف پول و درگاه بانکی.
 *
 * @param {Object} props
 * @param {React.Dispatch<SetStateAction<boolean>>} props.setIntroducingTheCreditor - تابع برای تغییر حالت نمایش معرفی صاحب اعتبار
 * @returns JSX.Element
 */

interface ContentValidationProps {
  onSuccess: () => void;
}

const ContentValidation = ({ onSuccess }: ContentValidationProps) => {
  const chosePayment = [
    // {id: 1,title: "aap",imgUrl: "./up.png",},
    { id: 1, title: "fanava", img: "/fanavar.png", name: "فن آوا" },
    // {id: 3,title: "pariz",imgUrl: "./pariz.png",},
    // {id: 4,title: "vandar",imgUrl: "./vandar2.png",},
  ];
  const [isOmenCraditWallet, setIsOmenCraditWallet] = useState(false);
  const [isOpenModalPayment, setIsOpenModalPayment] = useState(false);
  const [paymentBank, setPaymentBank] = useState("fanava");
  const [isLoadingWallet, setIsLoadingWallet] = useState(false);

  const itemsList = [
    "تصویر شناسنامه",
    "تصویر کارت ملی (پشت و رو)",
    "تصویر چک صیادی",
    "مدارک شغلی (فیش حقوقی برای کارمندان دولتی؛ فیش حقوقی یا معرفی‌نامه شرکت برای کارمندان خصوصی و جواز کسب برای صاحبین مشاغل آزاد)",
  ];

  const { data, isLoading, isError } = useQuery({
    queryKey: ["payment-walet-balance"],
    queryFn: fetchUserLastInquiry,
  });

  const {mutate: fetchPaymentCharge,data: postPaymentChargeData,error: errorPaymentCharge,} = useMutation({
    mutationFn: postPaymentWallet,
    onSuccess: (data: any) => {
      setIsLoadingWallet(false);
      setIsOmenCraditWallet(false);
      // window.location.reload();
      onSuccess()
    },
    onError: (error: AxiosError<{ message: string }>) => {
      setIsLoadingWallet(false);
      toast.error(error?.response?.data?.message);
      setIsOmenCraditWallet(false);
    },
  });

  const { mutate: fetchRequestSendBank } = useMutation({
    mutationFn: postRequestSendBank,
    onSuccess: (data: any) => {

      const url = data?.data?.url;

      if (!url) {
        toast.error("Payment URL not found in response");
        return;
      }

      setIsOmenCraditWallet(false);

      window.location.assign(url);
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message);
    },
  });

  const numberSeparator = useThousandsSeparator;

  const onSubmitWalletPayment = () => {
    setIsLoadingWallet(true);
    fetchPaymentCharge();
  };

  const handleSubmitPayment = () => {
    fetchRequestSendBank({ gateway: paymentBank });
  };

  return (
      <StackKit>
        <StackKit sx={{ width: "100%" }} direction={"column"} justifyContent={"start"}>
          <TypoGraphyKit variant="body1" className="text-right">
            هزینه اعتبارسنجی {toPersianNumber(`20 کارت`)} ؛{" "}
            {numberSeparator(`${data?.pay_credited}`)} ریال میباشد. شما میتوانید
            از طریق یکی از روش های زیر، هزینه اعتبار سنجی را پرداخت نمایید.
          </TypoGraphyKit>
        </StackKit>
        <StackKit direction={"row"} justifyContent={"flex-start"} sx={{ width: "100%", marginTop: "10px", marginBottom: "50px" }} gap={7}>
          <CustomButton onClick={() => setIsOmenCraditWallet(true)}>
            پرداخت هزینه اعتبار سنجی از طریق کیف پول {toPersianNumber(20)} کارت
          </CustomButton>
          <CustomButton onClick={() => setIsOpenModalPayment(true)}>
            پرداخت هزینه اعتبار سنجی از طریق درگاه بانکی{" "}
          </CustomButton>
        </StackKit>
        <Divider component={"div"} sx={{ width: "100%" }} />
        <StackKit direction={"column"} sx={{ textAlign: "right", width: "100%", padding: "10px" }}>
          <TypoGraphyKit variant="h6">راهنمای اعتبارسنجی ساعی پی</TypoGraphyKit>
          <TypoGraphyKit variant="body1">
            قبل از دریافت اعتبار از ساعی پی؛ انجام فرآیند اعتبار سنجی الزامی
            میباشد.
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1">
            در این فرآیند , شما باید پس از طی کردن فرآیندهای استعلام قضایی و بانکی
            ؛ جهت ضمانت؛ تصویر چک صیادی را بارگذاری نمایید.
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1">
            اگر چک صیادی به نام شخص شما نیست؛ شما باید در مرحله معرفی فرد صاحب
            اعتبار ، مشخصات صاحب چک را به عنوان ضامن خود وارد نمایید{" "}
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1">
            اگر چک صیادی به نام خود شما باشد، در مرحله معرفی فرد صاحب اعتبار،
            مشخصات خودتان را وارد نمایید.
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1">
            مدارک لازم جهت انجام اعتبار سنجی:{" "}
          </TypoGraphyKit>
          <List sx={{ direction: "rtl" }}>
            {itemsList.map((item, index) => (
                <ListItem key={index} sx={{ textAlign: "right" }}>
                  <ListItemIcon sx={{ minWidth: "24px", color: "#555" }}>
                    <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ color: "#fff" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary={item} sx={{ textAlign: "right" }} />
                </ListItem>
            ))}
          </List>
        </StackKit>

        {/* AlertDialog for Wallet Payment with Loading State */}
        <AlertDialog
            onAgree={onSubmitWalletPayment}
            open={isOmenCraditWallet}
            onClose={() => !isLoadingWallet && setIsOmenCraditWallet(false)}
            agreeText="بله"
            disagreeText="خیر"
            isHeader
            onDisagree={() => !isLoadingWallet && setIsOmenCraditWallet(false)}
            header={<TypoGraphyKit variant="h6">پرداخت از طریق کیف پول</TypoGraphyKit>}
            heightMain="250px"
        >
          <StackKit>
            {isLoadingWallet ? (
                <StackKit direction="column" alignItems="center" justifyContent="center" sx={{ py: 3 }}>
                  <TypoGraphyKit variant="body1" sx={{ mb: 2 }}>
                    در حال پردازش پرداخت...
                  </TypoGraphyKit>
                  {/* Loading Spinner */}
                  <div style={{width: "40px", height: "40px", border: "4px solid #f3f3f3", borderTop: "4px solid #1976d2", borderRadius: "50%", animation: "spin 1s linear infinite"}} />
                  <style>
                    {`
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                    `}
                  </style>
                </StackKit>
            ) : (
                <TypoGraphyKit variant="body1">
                  آیا مایلید هزینه اعتبار سنجی از کیف پولتان کسر شود؟
                </TypoGraphyKit>
            )}
          </StackKit>
        </AlertDialog>

        {/* AlertDialog for Bank Payment */}
        <AlertDialog onAgree={handleSubmitPayment} open={isOpenModalPayment} onClose={() => setIsOpenModalPayment(false)} agreeText="بله" disagreeText="خیر" isHeader header={<TypoGraphyKit variant="h6">پرداخت از درگاه آنلاین </TypoGraphyKit>} heightMain="400px">
          <StackKit>
            <TypoGraphyKit variant="body1">
              شما در حال پرداخت از طریق درگاه می باشید.لطفا درگاه مورد نظر خود
              را انتخاب نمایید
            </TypoGraphyKit>
            <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"center"} gap={1}>
              {chosePayment.map((item) => {
                const isActive = paymentBank === item.title;
                return (
                    <BoxKit key={item.title} sx={{width: "100px",height: "80px",bgcolor: "#fff",borderRadius: "10px",position: "relative",padding: "10px",cursor: "pointer",boxShadow: isActive ? "0 0 0 2px #1976d2" : "none",}} onClick={() => setPaymentBank(item.title)}>
                      {!isActive && (
                          <div style={{background: "#7c7c7d",opacity: 0.5,borderRadius: "10px",position: "absolute",top: 0,left: 0,bottom: 0,right: 0,}} />
                      )}

                      <img src={item.img} alt={item.title} style={{width: "100%",height: "100%",objectFit: "contain",}}/>
                    </BoxKit>
                );
              })}
            </StackKit>
          </StackKit>
        </AlertDialog>
      </StackKit>
  );
};

export default ContentValidation;